import { useEffect, useState } from "react";
import { FolderPlus, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";

export function AttachReportDialog({ report, onDone }) {
  const [open, setOpen] = useState(false);
  const [list, setList] = useState(null);
  const [busy, setBusy] = useState(null);
  useEffect(() => { if (open) api.get("/dossiers").then((r) => setList(r.data)); }, [open]);
  const attached = report.dossier_ids || [];
  const attach = async (d) => {
    setBusy(d.id);
    try { await api.post(`/dossiers/${d.id}/attach-watch-report/${report.id}`); toast.success(`Rapport joint au dossier ${d.reference}`); setOpen(false); onDone?.(d.id); }
    catch (e) { toast.error(errMsg(e)); }
    setBusy(null);
  };
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild><button data-testid="report-attach-dossier-button" className="h-8 px-3 rounded border border-primary/60 text-primary text-xs flex items-center gap-1 hover:bg-primary/10"><FolderPlus size={11} />Joindre au dossier</button></DialogTrigger>
      <DialogContent data-testid="report-attach-dialog"><DialogHeader><DialogTitle>Joindre {report.reference} à un dossier d'enquête</DialogTitle><DialogDescription>Le rapport sera intégré au brouillon IA [V#] et aux exports du dossier.</DialogDescription></DialogHeader>
        {!list ? <Loader2 className="animate-spin" /> : !list.length ? <div className="text-sm text-muted-foreground">Aucun dossier accessible. Créez d'abord un dossier.</div> : (
          <div className="max-h-80 overflow-auto divide-y border rounded">{list.map((d) => {
            const done = attached.includes(d.id);
            return (
              <button key={d.id} disabled={done || busy} onClick={() => attach(d)} data-testid={`report-attach-dossier-${d.id}`} className="w-full text-left px-3 py-2.5 text-sm hover:bg-accent disabled:opacity-50 flex items-center gap-2">
                <span className="font-mono text-xs text-primary">{d.reference}</span><span className="truncate">{d.title}</span>
                <span className="ml-auto text-[10px] text-muted-foreground">{done ? "déjà joint" : busy === d.id ? <Loader2 size={12} className="animate-spin" /> : d.status}</span>
              </button>);
          })}</div>)}
      </DialogContent>
    </Dialog>
  );
}
